import { useSearchParams } from "react-router-dom";
import channels from "./channels.js";
import { Container, CategoriaTitulo, ListaCanais, Channel } from "./styles.js";
import WatchChannel from "./watch/index.js";
import { PopUpContainer } from "../movie-details/pop-up-mark-watched/styles.js";
import { useEffect } from "react";

export default function Channels() {
  const [searchParams] = useSearchParams();

  const category = searchParams.get("category");
  const channel = searchParams.get("channel");

  useEffect(() => {
    if (category && category) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [category, channel]);

  return (
    <Container>
      <h1>Canais</h1>
      {channels.map((categoria) => (
        <div key={categoria.category}>
          <CategoriaTitulo>{categoria.category}</CategoriaTitulo>
          <ListaCanais>
            {categoria.channels.map((canal) => (
              <Channel
                to={`?category=${String(categoria?.category).toLowerCase()}&channel=${String(canal?.name).toLowerCase()}`}
                key={canal.name}
                background={canal.background || "#fff"}
                no_padding={canal?.no_padding || false}
              >
                <div className="thumb">
                  <img src={canal.image} alt={canal.name} />
                </div>
                <h4 className="name">{canal.name}</h4>
              </Channel>
            ))}
          </ListaCanais>
        </div>
      ))}
      {category && channel && (
        <PopUpContainer>
          <WatchChannel category={category} channel={channel} />
        </PopUpContainer>
      )}
    </Container>
  );
}
